import { z } from 'zod';

/**
 * `GET /me/company` — resolves a `user`/`admin` user's single company for
 * post-login landing. Stubbed ahead of the bootstrap flow (invitation/
 * self-serve/SSO), which doesn't exist yet — no UI creates
 * `company_memberships` rows; only tests/manual seeding does. 404 when the
 * caller has no membership (the normal case today, since no global
 * `pms_user`/`pms_admin` user has one and no bootstrap flow exists to
 * create one).
 */
export const myCompanyMembershipSchema = z.object({
  companyId: z.string().uuid(),
});
export type MyCompanyMembership = z.infer<typeof myCompanyMembershipSchema>;
